import * as React from 'react';
import { ICoordinate, IMapProps } from './IMap';
import './Map.scss';
import { roundToFour } from '../../app/MACRA_1/components/InputForm/Geometry/utils';

const defaultCoordinate: ICoordinate = {
    latitude: 41.9,
    longitude: 12.49,
};

const Map = (props: IMapProps) => {
    const divMap = React.useRef(null);
    let layer: any = null;

    React.useEffect(() => {
        let coordinates: ICoordinate = defaultCoordinate;
        if (!!props.coordinates?.latitude && !!props.coordinates?.longitude) {
            coordinates = {
                latitude: props.coordinates.latitude,
                longitude: props.coordinates.longitude,
            };
        }
        const map = window.L.map(divMap.current!).setView([coordinates.latitude!, coordinates.longitude!], 4);

        if (!!props.coordinates?.latitude && !!props.coordinates?.longitude) {
            layer = window.L.marker([coordinates.latitude!, coordinates.longitude!]).addTo(map);
        }
        const onMapClick = (e: any) => {
            let latLng: ICoordinate = { latitude: roundToFour(e.latlng.lat), longitude: roundToFour(e.latlng.lng) };
            if (layer != null) {
                layer.remove();
            }
            layer = window.L.marker([latLng.latitude!, latLng.longitude!]).addTo(map);
            props.onClick(latLng);
        };

        window.L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 19,
            attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
        }).addTo(map);

        map.on('click', onMapClick);
    }, []);

    return <div className='mapContainer' ref={divMap}></div>;
};

export default Map;
